import { render, staticRenderFns } from "./MenuAreaAdm.vue?vue&type=template&id=53f6bcc3&scoped=true"
import script from "./MenuAreaAdm.vue?vue&type=script&lang=js"
export * from "./MenuAreaAdm.vue?vue&type=script&lang=js"
import style0 from "./MenuAreaAdm.vue?vue&type=style&index=0&id=53f6bcc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6bcc3",
  null
  
)

export default component.exports